import { animation } from "./_animation.js";
// import { common } from "./_common.js";
import { drawer } from "./_drawer.js";
animation();
// common();
drawer();